export default __webpack_public_path__ + "static/insertion-dark-87e814cdc74a600f2799b78624907cd5.png";